import { IHttpProvider } from 'angular';
import { IJwtOptionsProvider } from '../interfaces';
import { StateService } from '@uirouter/angularjs';
import { GmcApi } from '../constants/gmc-api';
import { AuthService } from '../services/auth/auth.service';
import { environment } from '../../../environments/environment';

export function httpConfig( $httpProvider: IHttpProvider, jwtOptionsProvider: IJwtOptionsProvider, gmcApi: GmcApi ) {
  const hosts = [
    environment.host,
    environment.uploadsHost
  ].map(( host ) => host.replace(/^(https?:)?\/\//, ''));

  jwtOptionsProvider.config({
    authHeader: 'Authorization',
    authPrefix: 'Bearer ',
    tokenGetter: [
      'options',
      'AuthService',
      ( options, authStorage: AuthService ) => {
        return authStorage.getToken();
      }
    ],
    whiteListedDomains: [
      'localhost',
      ...hosts
    ],
    unauthenticatedRedirector: [
      '$state',
      'AuthService',
      ( $state: StateService, authService: AuthService ) => {
        authService.clearAuth();
        $state.go('app.public.auth.login');
      }
    ]
  });
  $httpProvider.interceptors.push('jwtInterceptor');
  $httpProvider.interceptors.push('isErrorInterceptor');
}

httpConfig.$inject = [
  '$httpProvider',
  'jwtOptionsProvider',
  'GmcApi'
];



// WEBPACK FOOTER //
// ./app/core/config/http.config.ts